import React from "react"

function SvgComponent(props) {
  return (
    <svg
      id="prefix__Capa_1"
      data-name="Capa 1"
      viewBox="0 0 512 512"
      {...props}
    >
      <defs>
        <style>{".prefix__cls-1{fill:#283f71}"}</style>
      </defs>
      <title>{"icons"}</title>
      <path
        className="prefix__cls-1"
        d="M88.82 443a4.23 4.23 0 01-.82 0 4 4 0 01-3.14-4.71l8.47-42.4a70.22 70.22 0 0124.13-40.33c7.92-6.53 16-10.75 24-12.55l57.17-16.59a8.71 8.71 0 002.39-1.12 8.49 8.49 0 003.69-6.08l2.38-20.55c-15.23-12.49-26.73-30.53-32.69-51.23-11-2.72-18.91-15.13-18.91-30.24 0-14.64 7.51-27 18.25-30.08a4 4 0 012.19 7.7c-7.32 2.09-12.44 11.29-12.44 22.38 0 12 6.35 22 14.46 22.75l2.79.25.71 2.71c5.5 20.86 17 38.92 32.32 50.86l1.78 1.39-2.89 25a16.52 16.52 0 01-11.8 14l-57.55 16.7c-6.82 1.5-13.81 5.18-20.78 10.93a62.15 62.15 0 00-21.38 35.72l-8.47 42.41a4 4 0 01-3.86 3.08zM423.64 443a4 4 0 01-3.92-3.22l-8.47-42.4a62.14 62.14 0 00-21.38-35.73c-7-5.75-14-9.43-20.78-10.93l-.26-.07-57.29-16.63a16.52 16.52 0 01-11.8-14l-2.89-25 1.78-1.39c15.34-11.94 26.82-30 32.32-50.86l.72-2.71 2.78-.25c8.11-.74 14.46-10.73 14.46-22.75 0-11.09-5.12-20.29-12.45-22.38a4 4 0 012.2-7.7c10.74 3.07 18.25 15.44 18.25 30.08 0 15.11-8 27.52-18.91 30.24-6 20.7-17.47 38.74-32.69 51.23l2.38 20.55a8.51 8.51 0 006.08 7.2L370.94 343c8 1.8 16.11 6 24 12.55a70.21 70.21 0 0124.13 40.34l8.47 42.39a4 4 0 01-3.14 4.71 4.23 4.23 0 01-.76.01z"
      />
      <path
        className="prefix__cls-1"
        d="M174.89 194.93a4 4 0 01-4-3.82c-.09-1.93-1.8-47.53 26-76.59 14.59-15.26 34.56-23 59.36-23s44.76 7.74 59.29 23c27.62 29 25.68 74.53 25.58 76.46a4 4 0 01-8-.4c0-.6 1.79-44.13-23.42-70.58-13-13.6-30.94-20.49-53.46-20.49s-40.52 6.9-53.54 20.49c-25.42 26.56-23.83 70.31-23.81 70.74a4 4 0 01-3.82 4.18z"
      />
      <path
        className="prefix__cls-1"
        d="M294.41 162.4a114.36 114.36 0 01-12.44-.71c-15.05-1.69-27.11-7.53-39.87-13.69-3.23-1.57-6.56-3.19-9.93-4.73-13-5.94-24.06-7.34-32.81-4.16-6.53 2.38-12.06 7.12-14.77 12.68a4 4 0 01-7.19-3.5 34.34 34.34 0 0119.23-16.7c10.79-3.92 23.86-2.44 38.86 4.4 3.46 1.58 6.84 3.22 10.11 4.81 12.12 5.9 23.57 11.47 37.25 13 17.79 2 32.58-.43 46.51-7.53a4 4 0 113.64 7.12 82.51 82.51 0 01-38.59 9.01zM256.25 387.45a4 4 0 01-2.88-1.22l-52.94-54.87a4 4 0 015.76-5.56l52.93 54.87a4 4 0 01-.1 5.66 4 4 0 01-2.77 1.12z"
      />
      <path
        className="prefix__cls-1"
        d="M256.25 387.45a4 4 0 01-2.88-6.78l52.93-54.87a4 4 0 015.76 5.56l-52.94 54.87a4 4 0 01-2.87 1.22z"
      />
      <path
        className="prefix__cls-1"
        d="M256.25 426.27A32.28 32.28 0 01232.5 416l-57.86-61.57a4 4 0 015.83-5.47l57.86 61.56a24.58 24.58 0 0035.83 0L332 349a4 4 0 115.83 5.47L280 416a32.28 32.28 0 01-23.75 10.27z"
      />
      <path
        className="prefix__cls-1"
        d="M256.23 510.69A254.91 254.91 0 0176 75.52 254.92 254.92 0 11436.48 436a253.23 253.23 0 01-180.25 74.69zm0-501.83a246.91 246.91 0 00-174.6 421.51 246.92 246.92 0 10349.2-349.19 245.31 245.31 0 00-174.6-72.32z"
      />
    </svg>
  )
}

export default SvgComponent
